import { KeyValue } from "../models/KeyValue";

export const NO_FILTERS_KEY_VALUE: KeyValue[] = [{ key: "NO_FILTER", value: "NO_FILTER" }];
